import type { BaselineTrackTarget, BenchmarkTarget } from '../types';
import { NotFoundError } from './errors';

export async function getBaselineTrackTarget({
  familyId,
}: {
  familyId: string;
}): Promise<BaselineTrackTarget> {
  try {
    const response = await fetch(
      `/api/mixone/api/v1/track/${familyId}/performance/benchmark?baseline=avg_comp`,
    );

    if (!response.ok) {
      const errorMessage = `Failed to fetch baseline track target: ${response.statusText}`;

      if (response.status === 404) {
        throw new NotFoundError(errorMessage);
      } else {
        throw new Error(errorMessage);
      }
    }

    const data = await response.json();

    return {
      familyId: data.family_id,
      firstWeekStreams: data.first_week_stream_count,
      secondWeekStreams: data.second_week_stream_count,
      firstYearStreams: data.first_year_stream_count,
    };
  } catch (error) {
    console.error('Error fetching baseline track target:', error);

    throw error;
  }
}

export async function getBenchmarkTargets({
  familyIds,
}: {
  familyIds: string[];
}): Promise<(BenchmarkTarget | Error)[]> {
  const trackTargetsOrErrors: (BenchmarkTarget | Error)[] = [];

  const promises = familyIds.map((id) =>
    // @TODO WMG1-489 - Call endpoint to get saved adjusted percent and combine with baseline data
    getBaselineTrackTarget({ familyId: id }),
  );

  // return those who are successful and catch errors for those who fail
  const results = await Promise.allSettled(promises);

  for (const result of results) {
    if (result.status === 'fulfilled') {
      const target = result.value;

      trackTargetsOrErrors.push({ ...target, adjustedPercent: 0 });
    } else {
      trackTargetsOrErrors.push(result.reason);
    }
  }

  return trackTargetsOrErrors;
}
